import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';
import TradeItem from '../TradeItem';

function DateRow({ date }) {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  const finalDate = date.toISOString().split('T')[0];

  return (
    <tr className={classnames([sharedStyles.tableRow, styles.historyRow])}>
      <td className={sharedStyles.tableCell} colSpan={4}>
        <TradeItem styles={[styles.dateCell]}>{finalDate}</TradeItem>
      </td>
    </tr>
  );
}

DateRow.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired
};

export default DateRow;
